var map = {
	"./feature/bibimbap.png": 6034,
	"./feature/boisson.png": 7617,
	"./feature/brunch.png": 1712,
	"./feature/bubble-tea.png": 8707,
	"./feature/burger.png": 3811,
	"./feature/cookie.png": 3734,
	"./feature/crepe.png": 2779,
	"./feature/curry.png": 2655,
	"./feature/donuts.png": 3687,
	"./feature/fromage.png": 2039,
	"./feature/gateaux.png": 3495,
	"./feature/glace.png": 5428,
	"./feature/matcha.png": 5628,
	"./feature/mille-crepe.png": 9483,
	"./feature/original.png": 2949,
	"./feature/pancake.png": 27,
	"./feature/pate.png": 9636,
	"./feature/piment.png": 5429,
	"./feature/pizza.png": 1716,
	"./feature/porc.png": 2294,
	"./feature/poulet.png": 6323,
	"./feature/poutine.png": 1372,
	"./feature/ramen.png": 4543,
	"./feature/ravioli.png": 7732,
	"./feature/rdv.png": 3174,
	"./feature/rolls.png": 1830,
	"./feature/steak.png": 3716,
	"./feature/sushi.png": 6700,
	"./feature/tea.png": 232,
	"./subplace/afrique.png": 1154,
	"./subplace/asie.png": 253,
	"./subplace/bistro.png": 8612,
	"./subplace/bubbletea.png": 4851,
	"./subplace/café.png": 7792,
	"./subplace/cake.png": 3743,
	"./subplace/chine.png": 8382,
	"./subplace/corée.png": 845,
	"./subplace/date.png": 9871,
	"./subplace/espagne.png": 612,
	"./subplace/france.png": 8554,
	"./subplace/image_picker_6939B4B3-E705-4CF3-BDE2-ACAA9E71C939-12454-000023CC157571B1.png": 4228,
	"./subplace/image_picker_E4CB9666-52BA-462C-8E0C-5331277270BE-11882-000024AF1CDDA204.png": 7422,
	"./subplace/inde.png": 5799,
	"./subplace/italie.png": 7621,
	"./subplace/japon.png": 7781,
	"./subplace/lux.png": 6680,
	"./subplace/mexique.png": 2841,
	"./subplace/portugal.png": 909,
	"./subplace/quebec.png": 3552,
	"./subplace/taiwan.png": 687,
	"./subplace/tea.png": 5617,
	"./subplace/usa.png": 7366,
	"./subplace/volonte.png": 4446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2807;